import { View, type ViewProps } from 'react-native';

export function NativeForm({ children, style, ...props }: ViewProps) {
  return (
    <View style={[{ gap: 16 }, style]} {...props}>
      {children}
    </View>
  );
}
